@if (customViewForm && opened) {
  <div class="view-sidebar-container" fxLayout="column">
    <form [formGroup]="customViewForm" fxLayout="column">
      <div fxFlex="100%" fxLayout="row" fxLayoutAlign="space-between center">
        <h3 fxLayout="row" fxLayoutAlign="start center">
          {{ editMode ? 'Edit ' + title : 'New ' + title }}
        </h3>
        <div class="button-container">
          <button
            mat-flat-button
            color="primary"
            type="submit"
            [disabled]="isSaving"
            (click)="onSave()"
          >
            <mat-icon>check</mat-icon> Save
          </button>
          <button
            type="button"
            type="reset"
            mat-stroked-button
            (click)="onClose()"
            [disabled]="isSaving"
          >
            <mat-icon>close</mat-icon> Cancel
          </button>
        </div>
      </div>
      <div class="view-contect" fxLayout="column">
        <div fxLayout="column" class="info-panel">
          <mat-form-field
            floatLabel="always"
            appearance="outline"
            hideRequiredMarker
          >
            <mat-label>Name</mat-label>
            <input
              matInput
              forbidAngleBrackets
              type="text"
              formControlName="viewName"
              placeholder="Required"
              maxlength="50"
            />
            @if (customViewForm.get('viewName').hasError('required')) {
              <mat-error> Name is required </mat-error>
            }
          </mat-form-field>
          <p>
            Only you will be able to see this view. If you would like to share
            this view with everyone else, click “Shared view” below."
          </p>
          <mat-checkbox formControlName="isPublic" color="primary"
            >Shared view</mat-checkbox
          >
        </div>
        @if (selectedView) {
          <div fxFlex fxLayout="row" fxLayoutAlign="center">
            <button mat-button color="primary" (click)="onSwitchMode()">
              <mat-icon>compare_arrows</mat-icon>
              {{
                isAdvancedViewMode
                  ? 'Switch to Quick Mode'
                  : 'Switch to Advanced Mode'
              }}
            </button>
          </div>
        }
        @if (!isAdvancedViewMode) {
          <div class="filter-panel-content">
            @if (selectedFilters.length == 0) {
              <p>No filters applied. Results showing all teams.</p>
            }
            @for (
              selectedFilter of selectedFilters;
              track selectedFilter;
              let i = $index
            ) {
              <div
                class="filters"
                [class.sub-filters-added]="selectedFilter.isSubFilterAdded"
              >
                <odata-filter-item
                  [selectedFilter]="selectedFilter"
                  [filters]="filters"
                  (delete)="deleteFilter(i)"
                  (addSubFilter)="addSubFilter(selectedFilter)"
                >
                </odata-filter-item>
                @if (selectedFilter.isSubFilterAdded) {
                  <div class="sub-filters">
                    <p class="sub-filters-title">Conditions</p>
                    @for (
                      selectedSubFilter of selectedFilter.selectedSubFilters;
                      track selectedSubFilter;
                      let i = $index
                    ) {
                      <div class="filters">
                        <odata-filter-item
                          [selectedFilter]="selectedSubFilter"
                          [filters]="selectedFilter.filter.subFilter.filters"
                          (delete)="deleteSubFilter(selectedFilter, i)"
                        >
                        </odata-filter-item>
                      </div>
                    }
                    <button
                      class="add-filter-button"
                      mat-button
                      color="primary"
                      (click)="addSubFilter(selectedFilter)"
                    >
                      + ADD ANOTHER CONDITION
                    </button>
                  </div>
                }
              </div>
            }
            <button
              class="add-filter-button"
              mat-button
              color="primary"
              (click)="addFilter()"
            >
              + ADD FILTER
            </button>
          </div>
          <div class="filter-panel-action-buttons">
            @if (!isValid && isApplied) {
              <p class="error-message">
                Please make sure to select all values, or remove the filter
                before applying.
              </p>
            }
          </div>
        }
      </div>
    </form>
    @if (isAdvancedViewMode) {
      @if (selectedView && isAdvancedViewMode) {
        <div class="filter-panel-content">
          <p>Type your query here</p>
          <mat-form-field class="query-textbox" appearance="outline">
            <textarea
              rows="4"
              matInput
              placeholder="exp: firstName eq 'John'"
              [(ngModel)]="selectedView.oDataQuery"
            ></textarea>
          </mat-form-field>
        </div>
      }
    }
    @if (displayLayouts?.length > 0) {
      <div fxFlex>
        <h4>Display Layout</h4>
        <mat-button-toggle-group
          [(ngModel)]="customViewDisplayLayout"
          class="layout-toggle-group"
        >
          @for (layout of displayLayouts; track layout) {
            <mat-button-toggle [value]="layout" aria-label="{{ layout }}">
              <mat-icon>{{ getIconForLayout(layout) }}</mat-icon>
            </mat-button-toggle>
          }
        </mat-button-toggle-group>
      </div>
    }
    @if (
      !canManageColumns &&
      customViewDisplayLayout == customViewDisplayLayoutEnum.Table
    ) {
      <app-plan-upgrade-box
        title="Upgrade to customize the displayed columns"
        body="You’ll be able to select which columns are on display from a wide range of data. Even better, you’ll be able to save the columns with your views, so you can set it and forget it."
      >
      </app-plan-upgrade-box>
    }
    @if (showManageColumns) {
      <lineup-manage-columns
        [columns]="columns"
        [viewContext]="selectedView.viewContext"
      ></lineup-manage-columns>
    }
  </div>
}
